module.exports = __webpack_public_path__ + "static/img/emptyImg_Eng.fa549007.png";